import { getAdsCountWithDate } from "@/services";
import { useQuery } from "react-query";

export const useGetAdsCountWithDateData = () => {
 const { data: adsCountWithDate, isLoading: getAdsCountWithDateIsLoading } =
  useQuery("adsCountWithDate", getAdsCountWithDate);
 return { adsCountWithDate, getAdsCountWithDateIsLoading };
};
